import LogoArabic from '@/assets/images/logo_arabic.png';
import LogoEnglish from '@/assets/images/logo_english.png';
import Ball from '@/assets/images/ball.png';

export { default as ArrowIcon } from '@/assets/images/arrow.svg?component';

export const Images = {
  LogoArabic,
  LogoEnglish,
  Ball
};
